/**
 * tp-slots-manual.js — 手填产能状态的渲染层(2026-08-05,简报 §5 任务卡 B)。
 *
 * 数据 = window.TPSlotManual(唯一 SSR 注入点 snippets/tp-slot-status.liquid,读 shop
 * metafield ops.slot_status)。本文件**不做任何日期过滤之外的数据加工**,只负责:
 *   ① 色带映射(下方 BANDS,改档位/文案只改这里) ② 五个展示点的 DOM。
 *
 * 五个展示点:
 *   ① 月历格子色点 + tooltip        → decorateDay(),由 tp-delivery-stepper.js renderDate() 调
 *   ② pct:0 / closed 真置灰不可选   → blocked(),由 tp-delivery-stepper.js dateAvailability() 调
 *   ③ PDP 可用性卡状态行            → renderPdp()(Express 池今+明,Advance 池 14 天最紧张一行)
 *   ④ PDP 确认卡日期选择器          → mountReadyDate()(2026-11-02 起;取代挂在 ③ 里的旧折叠日历)。
 *      点可订日 = 记「意向日期」(sessionStorage,TPSlots.intent)+ 写购物车日期,购物车 stepper
 *      进日期步时自动带入并用它自己的规则复核 —— 方式/邮编在 PDP 都还不知道,这里只记意向、绝不承诺
 *   ⑤ 购物车/cart stepper 状态药丸 + 红/深红内联警示条 → renderCartStatus()
 *
 * 纪律:
 *   - 全部 createElement,本仓禁 innerHTML(同 tp-delivery-stepper.js:10)
 *   - 渐进增强:window.TPSlotManual 不存在(metafield 空/损坏/被删)→ 所有 API 返回中性值,
 *     页面保持现有静态文案,零报错
 *   - 绝不显示百分比或精确剩余数(合规闸);"filling up fast" 类速度宣称禁用
 *   - 绿档只在只读日历里出现,PDP/购物车黄档及以下才现身(店主已批口径)
 */
(function () {
  if (window.TPSlots) return;

  // ── P1-T7a · 埋点辅助(2026-08-20,契约 reports/2026-08-20-t7-event-contract.md)──
  // 走 TPTrack 共享通道(排队等 gtag,consent 拒绝自弃);TPTrack 缺席时静默。
  // tp_date_blocked_click = 顾客**点击**了不可选日期(booked/closed/advance_lead_time),
  // 与 stepper 渲染时的自动状态发射(tp_fulfillment_blocked)语义不同,两者不可混算。
  function tpEvt(name, params) {
    try { if (window.TPTrack) window.TPTrack.event(name, params); } catch (e) { /* never throw */ }
  }
  var tpClickSeen = {};
  function tpBlockedClick(iso, reason, idx) {
    try {
      var k = iso + '|' + reason;
      if (tpClickSeen[k]) return; // 每格×每原因×每页面加载 1 次
      tpClickSeen[k] = 1;
      tpEvt('tp_date_blocked_click', {
        funnel_stage: 'delivery', reason: reason,
        days_ahead: idx < 0 ? null : (idx <= 2 ? String(idx) : '3plus')
      });
    } catch (e) { /* never throw */ }
  }

  // ── 色带配置(唯一一处;改档位/文案只改这个区块,五个展示点同时生效) ──────────
  // 店主 2026-08-05 第二轮定稿(B 套「加紧迫」),阶梯必须单调:
  //   available → booking up → almost full → last spots → fully booked
  // 🔴 合规红线(闸口已定,别自己往回加):禁 "filling up fast"/"going fast" 一类**速度**宣称
  //    (手填百分比背书不了"快");禁显示百分比或精确剩余数。
  // 字段:rank=「谁更紧张」排序 · alert=有内联警示条的档位(值 = ALERT 里的稿名)
  //      inPdp:false=这一档不进 PDP 可用性卡(购物车与只读日历照出)
  //      urge=确认卡选这天后跟在药丸后的促单句(店主 11/2 第三轮:标签加紧迫感;「下单」才锁位,不写加购就锁)
  var BANDS = [
    { key: 'green',   min: 61, max: 100, label: 'Open to book',                    rank: 1, inPdp: false },
    { key: 'yellow',  min: 31, max: 60,  label: 'Popular date — limited spots',    rank: 2, urge: 'Order soon to get your spot.' },
    { key: 'red',     min: 16, max: 30,  label: 'Almost fully booked',             rank: 3, alert: 'red', icon: true, urge: 'Order now to lock in your spot.' },
    { key: 'crimson', min: 1,  max: 15,  label: 'Last few spots',                  rank: 4, alert: 'crimson', pulse: true, urge: 'This date is down to its last spots — order now to lock in your spot.' },
  ];
  // pct:0(订满)与 closed(休假)是**两种状态两种文案**,绝不混用
  var BOOKED = { key: 'booked', label: 'Fully booked', rank: 5, blocked: true };
  var CLOSED = { key: 'closed', label: 'Closed', tip: 'We’re closed this day', rank: 5, blocked: true };

  // ── 节假日(2026-08-31 店主令)────────────────────────────────────────────
  // holiday:true = 这天**照常开门,但营业时间可能与平时不同**。与档位(pct)、关档位(off)
  // 都正交:它不是一个档位,不参与 BANDS 阶梯,也不影响可选/置灰 —— 只多说一句
  // 「以页面上能选的时间为准」。哪几档真的开、哪几档关,店主仍然用 off 逐档配,
  // 客人看到的时间列表本来就是真相,这行字只是把它点破。
  // closed(整天不开门)的日子不出这句(Liquid 侧已不透出,这里再挡一次)。
  // 文案纪律:不写具体几点(店主没在这里填过时间,写死就是编);不做产能/速度宣称。
  var HOLIDAY = {
    label: 'Holiday hours',
    // method 来自购物车 stepper(客人已经选了取货/配送就说那一种);PDP 上还不知道 → 通用句。
    txt: function (d, method) {
      var head = 'Holiday hours on ' + d + ' — our times that day may differ from usual. ';
      if (method === 'delivery') return head + 'The delivery windows shown here are the ones we’re running that day — pick whichever suits you.';
      if (method === 'pickup') return head + 'The pickup times shown here are the ones we’re open — pick one and come within that window.';
      return head + 'You’ll see the time slots we’re running that day when you choose your time in the cart — pick one and come within that window.';
    },
  };

  var ALERT = {
    red: function (d) { return 'Availability for ' + d + ' is limited — complete your order soon to secure your spot.'; },
    // 深红句原为 "…is almost full",但 B 套把 "Almost full" 给了**红档**药丸 —— 同一句话
    // 出现在两个不同档位会让阶梯读乱,故改为 "down to its last spots"(与深红药丸同义,
    // 仍是 1–15% 剩余撑得住的说法,不含速度宣称也不含数字)。
    crimson: function (d) { return 'Heads up — ' + d + ' is down to its last spots. Complete your order soon to secure your spot.'; },
  };

  var CAL_DAYS = 30;      // 日历覆盖天数 —— 角标计数范围 == 展开可见范围(验收要求严格一致)
  var ADVANCE_SCAN = 14;  // Advance 池摘要行扫描天数(从**可订的**第一天起,见 renderPdp)
  var ADVANCE_MIN_DAYS = 2; // Advance 池最早可订 = 后天,与 tp-delivery-stepper dateAvailability 同一规则

  // ── 意向日期(PDP → 购物车的唯一通道) ─────────────────────────────────────
  // 存 sessionStorage 而不是 cart attributes:①购物车可能还不存在 ②stepper 换方式/换邮编
  // 会清空日期,提前写进去必被冲掉 ③未经购物车复核的日期不配进订单属性。
  var INTENT_KEY = 'tp_pdp_date_intent';
  function intentGet() { try { var v = sessionStorage.getItem(INTENT_KEY); return (v && /^\d{4}-\d{2}-\d{2}$/.test(v)) ? v : null; } catch (e) { return null; } }
  function intentSet(iso) { try { sessionStorage.setItem(INTENT_KEY, iso); } catch (e) {} }
  function intentClear() { try { sessionStorage.removeItem(INTENT_KEY); } catch (e) {} }

  // ── PDP 选的日期同步进**服务器端**购物车属性(店主令 2026-09-07)────────────
  // 上面那段注释的第 ③ 条("未经购物车复核的日期不配进订单属性")被店主推翻,原因是
  // 订单 TPS6782TO:客人加购后离开,71 分钟后**直接落在 shop.app 的 Shop Pay 结账页**
  // (Shop app 通知/挽回邮件把购物车整个带过去),来源 direct、全程没经过我们的站点。
  // 那条路上我们的主题、结账闸门、日期步进器一行代码都不存在 —— **只有已经落在服务器
  // 购物车属性里的东西跟得过去**。sessionStorage 里的意向日期跟不过去,等于没有。
  // 取舍(店主已知并接受):这样写进去的日期**尚未在购物车里复核过方式/时段**,可能与
  // 最终配送方式不匹配;但"有一个客人亲手点过的日期"远好过"什么都没有,排不了产"。
  // 客人一进购物车走步进器,revalidate()/selectMethod() 会照常复核并纠正。
  //
  // ⚠️ 并发纪律(2026-08-23 事故根因,不许重犯):页面上若已有 stepper 实例,一律借它的
  // single-flight 队列写,**绝不另开一条并发 POST** —— 并发写乱序覆盖正是当初丢日期的原因。
  // 没有 stepper(购物车为空 → 步进器不渲染)时才直接写,此时不存在第二个写入者。
  function cartDateSync(iso) {
    try {
      var st = document.querySelector('tp-delivery-stepper');
      if (st && st.state && typeof st.persist === 'function') {
        if (st.state.date === (iso || null)) return;              // 无变化,不产生多余写入
        st.state.date = iso || null;
        // 日期决定哪些时段合法 —— 与 stepper 的 selectDate() 保持同一套字段重置
        st.state.windowId = st.state.windowLabel = st.state.windowKind = null;
        st.state.surcharge = '0';
        st.persist();                                             // ← 走队列,不并发
        // 时段清空了,下午档附加费行也得撤 —— 只 persist 不 reconcile 会留下「有 $14.95 行、
        // 没有时段」的订单(TPS6991TO,2026-09-28 查明)。reconcileFees 自带 single-flight。
        if (typeof st.reconcileFees === 'function') st.reconcileFees();
        if (typeof st.render === 'function') st.render();
        return;
      }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { tp_delivery_date: iso || '' } }),
      }).then(function () {
        // 广播给「之后才出现」的 stepper 实例(source 非本人 → 它会从 /cart.js 重新读)
        try { document.dispatchEvent(new CustomEvent('tp:delivery-updated', { detail: { source: 'tp-slots-pdp' } })); } catch (e) {}
      }).catch(function () {});
    } catch (e) { /* 同步失败绝不能影响 PDP 本身 */ }
  }

  // ── 池切换出口(P1B-B4,店主 2026-08-25 令)──────────────────────────────
  // 历史:两池切换链接 2026-07-28 曾从可用性卡挪到首屏池条("一页两处同类出口")。
  // 店主 8/25 令在**被挡住的那一刻**就地再给一次出口:Advance 蛋糕点了今/明 →
  // 提前期卡片里给 Express 版链接;Express 蛋糕(本来就不渲染日历,没有可点的
  // 挫败时刻)→ 状态行下常驻一行 Advance 版出口。目的地与文案不另造,直接克隆
  // 首屏池条那颗 CTA(counterpart 配对有 = 同款直达,没有 = 集合兜底 ——
  // 池条怎么算这里就怎么跟,单一真相源,文案也全是已批口径)。
  function poolCta(kind) {
    var el = document.querySelector('.tp-cfg__pool--' + kind + ' .tp-cfg__pool-cta');
    if (!el) return null;
    var href = el.getAttribute('href'), label = el.textContent.replace(/\s+/g, ' ').trim();
    return (href && label) ? { href: href, label: label } : null;
  }
  // 曝光与 stepper guidance 同口径:可见 ≥50% 且停留 ≥1s,每页面加载每 context 1 次
  var altImpSeen = {};
  function altImpressionOnce(el, context) {
    if (!el || altImpSeen['io_' + context] || !('IntersectionObserver' in window)) return;
    altImpSeen['io_' + context] = 1;
    var timer = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.intersectionRatio >= 0.5) {
          if (!timer) timer = setTimeout(function () {
            if (!altImpSeen[context]) {
              altImpSeen[context] = 1;
              tpEvt('tp_alt_express_impression', { funnel_stage: 'delivery', context: context });
            }
            io.disconnect();
          }, 1000);
        } else if (timer) { clearTimeout(timer); timer = 0; }
      });
    }, { threshold: [0, 0.5] });
    io.observe(el);
  }
  // kind = 当前页所在池('advance' 页的池条 CTA 指向 Express,反之亦然)
  // carry = 把客人已选的尺寸/版本/口味/无蛋带到对家商品页(?from=swap…,配置器 fromFinder 同一条回填通道)
  function altLink(kind, context, carry) {
    var src = poolCta(kind); if (!src) return null;
    var isProduct = src.href.indexOf('/products/') >= 0;
    var target = kind === 'advance'
      ? (isProduct ? 'express_product' : 'express_collection')
      : (isProduct ? 'advance_product' : 'advance_collection');
    var href = src.href;
    if (carry && isProduct) { var sel = cfgSelection(); if (sel && sel.any) href = swapHref(href, sel, kind); }
    var a = h('a', { class: 'tp-slot-alt__link', href: href }, [src.label]);
    a.addEventListener('click', function () {
      tpEvt('tp_alt_express_click', { funnel_stage: 'delivery', context: context, target: target });
    });
    return a;
  }

  // ── 今明两格 → 原地给「切到 Express 版」按钮,带着已选项过去(店主 2026-11-03)────────
  // 11/2–11/3 实测:71 个看到确认卡的会话里 15 个点了今明两格,只有 3 个点了那行小链接 ——
  // 链接要客人到新页重选尺寸口味。现在改成按钮:选项经 ?from=swap&tp_size…带过去(配置器
  // fromFinder 同一条回填通道,落地收成一条「Switched from the advance-order version」),点的
  // 那天经 intentSet 带过去(Express 页确认卡直接点上),差价现场算:拉对家商品的公开
  // /products/<handle>.js(~13KB,点今明时才拉,拉一次缓存)。没配对商品(池条 CTA 落到
  // 集合)时照旧给文字链接。只读配置器 DOM,不碰它的内部 state。
  var cpCache = {};
  function cpFetch(href) {
    var u = String(href).split('?')[0].split('#')[0];
    if (!cpCache[u]) cpCache[u] = fetch(u + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cpCache[u];
  }
  function optRole(name) { return /^size$/i.test(name) ? 'size' : /^version$/i.test(name) ? 'version' : /^flavou?r$/i.test(name) ? 'flavor' : null; }
  function cfgSelection() {
    var root = document.querySelector('[data-tp-cfg]'); if (!root) return null;
    var sel = { vals: {}, price: null, eggless: false, any: false };
    Array.prototype.forEach.call(root.querySelectorAll('[data-tp-step][data-tp-pos]'), function (st) {
      var cur = st.querySelector('[data-tp-option]:checked'), role = st.getAttribute('data-tp-step');
      if (cur && (role === 'size' || role === 'version' || role === 'flavor')) { sel.vals[role] = cur.value; sel.any = true; }
    });
    var egg = root.querySelector('[data-tp-eggless]'); sel.eggless = !!(egg && egg.checked);
    try {
      var vs = JSON.parse(root.querySelector('[data-tp-variants]').textContent);
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-tp-option]:checked'), function (i) { return [+i.getAttribute('data-tp-position'), i.value]; });
      for (var i = 0; i < vs.length && sel.price == null; i++) {
        if (chosen.every(function (c) { return vs[i].options[c[0] - 1] === c[1]; })) sel.price = vs[i].price;
      }
    } catch (e) {}
    return sel;
  }
  // 对家商品里找同选项的变体:先全同;口味对不上再放开口味(同尺寸同版本里最便宜的那个)
  function cpMatch(prod, sel) {
    if (!prod || !prod.variants || !prod.options) return null;
    var roles = prod.options.map(function (o) { return optRole(o && o.name != null ? o.name : o); });
    function pick(skipFlavor) {
      var best = null;
      prod.variants.forEach(function (v) {
        if (!v.available) return;
        for (var k = 0; k < roles.length; k++) {
          var r = roles[k]; if (!r || !sel.vals[r] || (skipFlavor && r === 'flavor')) continue;
          if (String(v.options[k]).toLowerCase() !== String(sel.vals[r]).toLowerCase()) return;
        }
        if (!best || v.price < best.price) best = v;
      });
      return best;
    }
    var v = pick(false); if (v) return { v: v, flavorKept: true };
    v = pick(true); return v ? { v: v, flavorKept: false } : null;
  }
  // pair = 客人现在所在的池(落地页用它写「Switched from the … version」)
  function swapHref(href, sel, pair) {
    var p = ['from=swap', 'tp_pair=' + pair];
    if (sel.vals.size) p.push('tp_size=' + encodeURIComponent(sel.vals.size));
    if (sel.vals.flavor) p.push('tp_flavor=' + encodeURIComponent(sel.vals.flavor));
    if (sel.vals.version) p.push('tp_version=' + encodeURIComponent(sel.vals.version));
    if (sel.eggless) p.push('tp_eggless=1');
    return href + (href.indexOf('?') >= 0 ? '&' : '?') + p.join('&');
  }
  function moneyDelta(cents) {
    var a = Math.abs(cents) / 100, s = '$' + (a % 1 ? a.toFixed(2) : a.toFixed(0));
    return cents > 0 ? '+' + s : cents < 0 ? '−' + s : 'same price';
  }
  // 提前订款商品页、点了今明两格之后的按钮。iso = 要带去的那天;dayWord = 'today' / 'tomorrow' / 'pickup today'
  function swapButton(iso, dayWord, context) {
    var src = poolCta('advance'); if (!src || src.href.indexOf('/products/') < 0) return null;
    var sel = cfgSelection() || { vals: {}, price: null, eggless: false, any: false };
    var bits = [sel.vals.size, sel.vals.flavor].filter(Boolean);
    var sub = h('small', null, [bits.length ? bits.join(' · ') + ' · your choices come with you' : 'your choices come with you']);
    var a = h('a', { class: 'tp-rd__xswap', href: swapHref(src.href, sel, 'advance'), 'data-tp-swap-btn': context },
      [h('b', null, ['Switch to the Express version ›']), sub]);
    var deltaTag = 'unknown';
    a.addEventListener('click', function () {
      intentSet(iso);   // Express 页的确认卡把这一天直接点上
      tpEvt('tp_alt_express_click', { funnel_stage: 'delivery', context: context, target: 'express_product', ui: 'button', detail: deltaTag });
    });
    cpFetch(src.href).then(function (prod) {
      if (!a.isConnected) return;
      var m = cpMatch(prod, sel), parts = [];
      if (!m) { deltaTag = 'no_match'; parts.push('pick your size on the next page'); }
      else {
        if (m.flavorKept) { if (bits.length) parts.push(bits.join(' · ')); }
        else parts.push((sel.vals.size ? sel.vals.size + ' · ' : '') + 'pick a flavour on the next page');
        // 贵出来的差价要说明原因(店主 11/3):提前订款的划线价是 Pre-order discount,Express 没这个折扣,不是另外加钱
        if (sel.price != null) { var d = m.v.price - sel.price; deltaTag = d > 0 ? 'more' : d < 0 ? 'less' : 'same'; parts.push(h('span', null, [h('em', null, [moneyDelta(d)]), d > 0 ? ' (pre-order discount doesn’t apply)' : ''])); }
        parts.push('ready ' + dayWord);
      }
      sub.textContent = '';
      parts.forEach(function (t, i) { if (i) sub.appendChild(document.createTextNode(' · ')); sub.appendChild(typeof t === 'string' ? document.createTextNode(t) : t); });
    });
    return a;
  }

  // 点了日期后轻推一下 Add to cart(只做注意力提示,不滚动不弹窗)
  function nudgeAtc() {
    var atc = document.querySelector('[data-tp-atc]');
    if (!atc) return;
    atc.classList.remove('tp-atc-nudge');
    void atc.offsetWidth; // 重启动画
    atc.classList.add('tp-atc-nudge');
  }

  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DOW_MIN = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var D = window.TPSlotManual;
  var LOADED = Date.now();

  // ── utils ─────────────────────────────────────────────────────────────────
  function h(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (k === 'class') e.className = attrs[k]; else if (attrs[k] != null) e.setAttribute(k, attrs[k]); });
    (children || []).forEach(function (c) { if (c == null) return; e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  function parseYMD(s) { var p = String(s).split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function fmtYMD(ms) { var d = new Date(ms), m = d.getUTCMonth() + 1, dd = d.getUTCDate(); return d.getUTCFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dd < 10 ? '0' : '') + dd; }
  function addDays(ms, n) { return ms + n * 86400000; }

  // 门店当地"今天" = SSR 时间戳 + 页面打开后经过的真实时间(同 tp-delivery-stepper 的 nowParts:
  // 标签页开一夜后不能还把昨天当今天)。绝不信设备时钟的日期。
  function todayMs() {
    if (!D || !D.today) return null;
    var base = Date.parse(D.today + 'T' + (D.time || '00:00') + ':00Z');
    if (isNaN(base)) return null;
    var d = new Date(base + (Date.now() - LOADED));
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  function niceDate(iso) { var d = new Date(parseYMD(iso)); return DOW[d.getUTCDay()] + ', ' + MON[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  function relLabel(iso) {
    var t = todayMs(); if (t == null) return niceDate(iso);
    var i = Math.round((parseYMD(iso) - t) / 86400000);
    return i === 0 ? 'Today' : i === 1 ? 'Tomorrow' : niceDate(iso);
  }

  // ── 查表 ──────────────────────────────────────────────────────────────────
  function dayFor(iso) {
    if (!D || !D.days || !iso) return null;
    var t = todayMs();
    if (t != null && parseYMD(iso) < t) return null; // 过去日期零影响
    var v = D.days[iso];
    return (v && typeof v === 'object') ? v : null;
  }
  function bandFor(iso) {
    var v = dayFor(iso); if (!v) return null;
    if (v.closed === true) return CLOSED;
    var p = v.pct;
    if (typeof p !== 'number' || !isFinite(p)) return null; // 结构不对 = 中性
    p = Math.floor(p);
    if (p <= 0) return BOOKED;
    if (p > 100) return null;
    for (var i = 0; i < BANDS.length; i++) if (p >= BANDS[i].min && p <= BANDS[i].max) return BANDS[i];
    return null;
  }
  // 给 dateAvailability() 用:返回置灰理由,可订则 null。两种状态两种文案。
  function blocked(iso) { var b = bandFor(iso); return (b && b.blocked) ? b.label : null; }

  // 这天被店主单独关掉的取货/配送档位 id(2026-08-05 加)。
  // 给 tp-delivery-stepper.js 的 pickupSlots()/windowsForDate() 过滤用 —— 本文件不碰档位语义,
  // 只把数组原样交出去(Liquid 已按白名单过滤过一遍)。休假日整天不开门,不谈关哪档。
  // 拿不到数据一律返回空数组 = 什么都不关(渐进增强:metafield 空/损坏 → 档位维持现状)。
  function offFor(iso) {
    var v = dayFor(iso);
    if (!v || v.closed === true || !Array.isArray(v.off)) return [];
    return v.off.filter(function (x) { return typeof x === 'string' && x; });
  }

  // 这天是不是节假日(开门但时间可能调整)。closed 的日子一律 false —— 整天不开门就没有
  // "时间可能调整"这回事。拿不到数据一律 false = 渐进增强,页面维持现状。
  function holidayFor(iso) {
    var v = dayFor(iso);
    return !!(v && v.closed !== true && v.holiday === true);
  }

  // ── 展示件 ────────────────────────────────────────────────────────────────
  function pill(band) {
    var kids = [];
    if (band.icon) kids.push(h('span', { class: 'tp-slot-pill__ico', 'aria-hidden': 'true' }, ['⚠']));
    else kids.push(h('span', { class: 'tp-slot-pill__dot' + (band.pulse ? ' is-pulse' : ''), 'aria-hidden': 'true' }, []));
    kids.push(h('span', { class: 'tp-slot-pill__txt' }, [band.label]));
    return h('span', { class: 'tp-slot-pill tp-slot-pill--' + band.key }, kids);
  }
  // 节假日提示卡:与档位警示条同一骨架(tp-slot-note),配色走中性焦糖 —— 它是**信息**,
  // 不是紧迫信号,抢了红/深红的视觉等级就会稀释真正的稀缺提示。
  function holidayPill() {
    return h('span', { class: 'tp-slot-pill tp-slot-pill--holiday' }, [
      h('span', { class: 'tp-slot-pill__ico', 'aria-hidden': 'true' }, ['🗓']),
      h('span', { class: 'tp-slot-pill__txt' }, [HOLIDAY.label]),
    ]);
  }
  function holidayNote(iso, method) {
    return h('div', { class: 'tp-slot-note tp-slot-note--holiday' }, [
      holidayPill(),
      h('p', { class: 'tp-slot-note__txt' }, [HOLIDAY.txt(niceDate(iso), method)]),
    ]);
  }

  function statusRow(iso, band) {
    return h('p', { class: 'tp-slot-row' }, [
      h('span', { class: 'tp-slot-row__when' }, [relLabel(iso)]),
      pill(band),
    ]);
  }

  // ── ① 月历格子色点 + tooltip(stepper renderDate 每格调用一次) ─────────────
  // ok = 这一格在 stepper 自己的规则下是否可订(dateAvailability().ok)。
  // 因**别的**原因订不了的日子(advance 蛋糕的今明、周日、邮编限定日…)不挂色点也不改 tooltip:
  // 一个点不动的灰格子上写 "Only a few spots left" 只会让人困惑,原来的理由文案更有用。
  function decorateDay(btn, iso, ok) {
    if (!btn) return;
    var band = bandFor(iso);
    // 节假日单独成立:这天可能一点产能数据都没有(店主只勾了节假日),照样要标出来。
    // 订满/休假的格子不标 —— 那天根本选不了,"时间可能调整"是废话。
    var hol = holidayFor(iso) && !(band && band.blocked);
    if (!band && !hol) return;
    if (!(band && band.blocked) && ok === false) return;
    var label = band ? (band.tip || band.label) : '';
    if (hol) label = label ? (label + ' · ' + HOLIDAY.label) : HOLIDAY.label;
    if (band) btn.classList.add('tp-slot-cell', 'tp-slot-cell--' + band.key);
    if (hol) btn.classList.add('tp-slot-cell', 'tp-slot-cell--holiday');
    btn.setAttribute('title', label);
    // 读屏:数字 + 状态词(色点是纯装饰,aria-hidden)
    btn.setAttribute('aria-label', (btn.textContent || '') + ' — ' + label);
    if (band && band.blocked) return; // 置灰格不挂色点,灰掉本身就是状态
    if (band) btn.appendChild(h('span', { class: 'tp-slot-cell__dot' + (band.pulse ? ' is-pulse' : ''), 'aria-hidden': 'true' }, []));
  }

  // ── ⑤ 购物车 / /cart stepper:紧贴日历下方的状态块 ──────────────────────────
  // 店主令 2026-08-05:**客人一选日期就在原地出现**(原来要等填完时间、而且挂在步进器最底部,
  // 滚不到 = 等于没做)。所以这里不再看 isComplete,只看有没有选中日期。
  // 红/深红档并成**一张卡**(药丸 + 警示句),不再单独重复一行日期 —— 警示句里已经带日期了,
  // 两处都写在手机窄屏上就是两行废话。
  function renderCartStatus(stepper) {
    if (!stepper || !stepper.querySelector) return;
    var box = stepper.querySelector('[data-tp-slot-status]'); if (!box) return;
    box.textContent = '';
    var iso = stepper.state && stepper.state.date;
    var band = iso ? bandFor(iso) : null;
    // 节假日与档位正交:这天可能没有任何档位数据,节假日提示也要出。
    var hol = iso ? holidayFor(iso) : false;
    // 店主 2026-08-05:**绿档在购物车要出**(客人点了空日子,给一句 Open to book 让他安心下单);
    // PDP 上仍然不出(见 BANDS 的 inPdp:false)。置灰档根本选不中(走 dateAvailability)。
    if ((!band || band.blocked) && !hol) { box.hidden = true; return; }

    if (band && !band.blocked) {
      if (band.alert) {
        box.appendChild(h('div', { class: 'tp-slot-note tp-slot-note--' + band.key }, [
          pill(band),
          h('p', { class: 'tp-slot-note__txt' }, [ALERT[band.alert](niceDate(iso))]),
        ]));
      } else {
        box.appendChild(statusRow(iso, band));
      }
    }
    // 节假日那句放**最后** —— 它讲的是「接下来选什么时间」,紧挨着下面的「Choose a time」。
    // 方式(取货/配送)客人在这一步已经选过了,直接说具体那一种,别让他自己对号入座。
    if (hol) box.appendChild(holidayNote(iso, stepper.state && stepper.state.method));
    box.hidden = !box.firstChild;
  }

  // ── ③ PDP 可用性卡 ────────────────────────────────────────────────────────
  function renderPdp() {
    if (!D) return;
    var t = todayMs(); if (t == null) return;
    // 一页正常只有一张可用性卡,用 querySelectorAll 是为了模板/预览里出现多张时也不会只画第一张
    Array.prototype.forEach.call(document.querySelectorAll('[data-tp-avail]'), function (card) { renderPdpCard(card, t); });
    renderPoolEarliest(t);
  }

  // ── P1B-B3 · 首屏池条「最早可订日」具体日期(2026-08-25)──────────────────────
  // 池条原来只有相对话("delivered from the day after tomorrow"),首屏四答里
  // 「最早什么时候拿到」缺一个可核对的日子。规则与 PDP 日历完全同源:
  // 从 max(产品 lead 天数, ADVANCE_MIN_DAYS) 起,取第一个非 booked/closed 天;
  // 没有产能数据的日子按可订处理(与日历 "Available to book" 同口径)。
  // 具体日期必须客户端算 —— 服务端渲染会被页面缓存冻住(相对话没这个问题)。
  // D 缺席时 renderPdp 直接不跑,元素保持 hidden = 渐进增强,零回归。
  function renderPoolEarliest(t) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tp-pool-earliest]'), function (el) {
      if (el._tpDone) return; el._tpDone = true;
      var lead = parseInt(el.getAttribute('data-tp-lead'), 10);
      if (isNaN(lead) || lead < ADVANCE_MIN_DAYS) lead = ADVANCE_MIN_DAYS;
      for (var i = lead; i < lead + CAL_DAYS; i++) {
        var iso = fmtYMD(addDays(t, i)), b = bandFor(iso);
        if (b && b.blocked) continue; // 订满/休假跳过,报一个订不了的日子是误导
        el.textContent = 'Earliest date: ' + niceDate(iso);
        el.hidden = false;
        return;
      }
      // 整个窗口全 blocked(极端情形)→ 保持 hidden,让日历自己讲话
    });
  }
  function renderPdpCard(card, t) {
    var mount = card.querySelector('[data-tp-slots-pdp]'); if (!mount || mount._tpDone) return;
    mount._tpDone = true;
    var express = card.getAttribute('data-tp-express') === 'true';

    if (express) {
      // P1B-B5(店主 8/25:今天/明天两条线各占一行,别混着讲)。
      // 「今天」的故事由上方倒计时行讲(cutoff 感知的 "Today — order in the next…"),
      // 这里今天只在**硬警示**(红/深红/订满/休假)时补一行 —— 黄档 "Booking up" 与
      // 倒计时的紧迫感重复,不再出声。「明天」永远出一行:有档位出档位;绿档/无数据
      // 出中性 "Available to book"(绿档不上 PDP 的既有口径不变,中性开放药丸不算产能宣称)——
      // 否则明天没档位数据时整行消失,客人不知道明天也能订,正是之前乱的根源。
      var tb = bandFor(fmtYMD(t));
      if (tb && (tb.blocked || tb.rank >= 3)) mount.appendChild(statusRow(fmtYMD(t), tb));
      // 店主 8/25 第三条:Tomorrow 行固定说 "also available"(与上行 Today 形成
      // 「今天能订、明天也能订」的连句),繁忙档位药丸跟在后面;订满/休假照实说,
      // 那时不能写 also available。
      var iso1 = fmtYMD(addDays(t, 1)), b1 = bandFor(iso1);
      // 节假日(2026-08-31):Express 只做今/明两天,这两天要是节假日就必须在这儿说 ——
      // 客人正是在这张卡上判断"今天还能不能拿到"。订满/休假的那天不说(见 holidayFor 用法)。
      var holToday = holidayFor(fmtYMD(t)) && !(tb && tb.blocked);
      if (holToday) mount.appendChild(holidayNote(fmtYMD(t), null));
      if (b1 && b1.blocked) mount.appendChild(statusRow(iso1, b1));
      else {
        var row1 = h('p', { class: 'tp-slot-row' }, [
          h('span', { class: 'tp-slot-row__when' }, ['Tomorrow']),
          h('span', { class: 'tp-slot-row__also' }, ['— also available']),
        ]);
        if (b1 && b1.inPdp !== false) row1.appendChild(pill(b1));
        mount.appendChild(row1);
      }
      if (holidayFor(iso1) && !(b1 && b1.blocked)) mount.appendChild(holidayNote(iso1, null));
    } else {
      // Advance 池最早可订 = 后天(dateAvailability 同一规则),从 i=2 起扫 14 个**可订**天。
      // 店主 8/27:证据行升级为「最紧的 1–2 天」且**包含已订满日**(rank 最高、最硬的证据,
      // 此前被 alert 过滤误伤跳过)——真日期用店主已批档位原话说话,休假日不算稀缺不进证据。
      var proofs = [];
      for (var i = 2; i < 2 + ADVANCE_SCAN; i++) {
        var iso2 = fmtYMD(addDays(t, i)), b2 = bandFor(iso2);
        if (!b2) continue;
        if (b2.key === 'booked' || b2.alert) proofs.push({ iso: iso2, band: b2 });
      }
      proofs.sort(function (a, b) { return b.band.rank - a.band.rank; });
      proofs.slice(0, 2).forEach(function (p) { mount.appendChild(statusRow(p.iso, p.band)); });
      // 旧的折叠日历 2026-11-02 起撤掉:日期改在确认卡里问(mountReadyDate),一页只留一个日历
    }
    mount.hidden = !mount.firstChild;
  }

  // ── P1B-B4 · Express 池:状态行下常驻一行 Advance 出口 ─────────────────────
  // Express 不渲染日历(30 天日历对"只做今明"是误导,既有决定不动),所以
  // 「想选更远的日期」没有可点的挫败时刻 —— 做成常驻行。不依赖产能数据 D:
  // 出口本身与产能无关,D 缺席时也要在。引导句复用池条已批口径 "Planning ahead?"。
  function renderExpressAlt() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tp-avail][data-tp-express="true"] [data-tp-slots-pdp]'), function (mount) {
      if (mount._tpAltDone) return; mount._tpAltDone = true;
      var alt = altLink('express', 'pdp_express_card');
      if (!alt) return;
      // 文案 "Need a later date?"(店主 8/25:比 "Planning ahead?" 更直说这行是干嘛的)
      var line = h('p', { class: 'tp-slot-alt tp-slot-alt--row' }, ['Need a later date? ', alt]);
      mount.appendChild(line);
      mount.hidden = false;
      altImpressionOnce(line, 'pdp_express_card');
    });
  }

  // ── ④ 确认卡日期选择器(2026-11-02 店主令,TP-SYNC-20261029-PDP-GUIDE-01 第五段)──────────
  // 商品页选齐后的确认卡里问「When do you need it?」:
  //   提前订款 = 5 周摊开月历(一下点中;Later dates 换下 5 周);今明两格标 Express,点了给切换链接
  //   Express 款 = Today / Tomorrow 两个大按钮(可选日少于 10 个用列表,NN/g)+ 一行截单 + 提前订出口
  // 今天/明天的判断与购物车 dateAvailability() 同一套数据(TPDeliveryData 的 CUTOFFS / NO_SAMEDAY_DOW /
  // PICKUP_SAMEDAY / PICKUP_WINDOWS + 本文件 blocked() / offFor()):过了配送截单只说「今天只能自提」,
  // 不替客人改配送方式。卡上不写配送时段(店主 11/2:有的区下午也能送,时段在购物车选)。
  // 产能档位(店主 11/2 第二轮):格子上色点 + 月历下图例 + 点选后提示里带档位药丸,红/深红再加已批促单句;
  // 只用 BANDS 已批文案,绿档格子不挂点、只在选中提示里写 Open to book,不报百分比、不做速度宣称。
  // 可订日走旧折叠日历同一条通道:intentSet + cartDateSync,购物车进日期步再复核。
  // 埋点 tp_ready_date_pick:step=ready_card · reason=ok|pickup_only|closed|express_only|too_soon
  //   · detail=距今天数档(0 / 1 / 2-6 / 7-13 / 14-27 / 28plus)。订满/休息照旧发 tp_date_blocked_click。
  var RD_WEEKS = 5, RD_MAX_DAYS = 180;   // 180 = 购物车 DATE_HORIZON_DAYS
  function rdNow() {
    if (D && D.today) {
      var base = Date.parse(D.today + 'T' + (D.time || '00:00') + ':00Z');
      if (!isNaN(base)) {
        var d = new Date(base + (Date.now() - LOADED));
        return { ms: Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), mins: d.getUTCHours() * 60 + d.getUTCMinutes() };
      }
    }
    // 没有产能数据时退回多伦多时钟(与配置器确认卡 rdNow 同法)
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (t) { for (var k = 0; k < p.length; k++) { if (p[k].type === t) return p[k].value; } return ''; };
      var hh = +g('hour'); if (hh === 24) hh = 0;
      return { ms: Date.UTC(+g('year'), +g('month') - 1, +g('day')), mins: hh * 60 + (+g('minute')) };
    } catch (e) { return null; }
  }
  function rdMins(s, fb) { if (!s) return fb; var a = String(s).split(':'); return (+a[0]) * 60 + (+a[1]); }
  function rdClock(m) { var hh = Math.floor(m / 60), mm = m % 60; return (hh % 12 || 12) + ':' + (mm < 10 ? '0' : '') + mm + ' ' + (hh >= 12 ? 'PM' : 'AM'); }
  function rdBucket(i) { return i <= 1 ? String(i) : i < 7 ? '2-6' : i < 14 ? '7-13' : i < 28 ? '14-27' : '28plus'; }
  function rdRange(a, b) {
    var x = new Date(a), y = new Date(b);
    return MON[x.getUTCMonth()] + ' ' + x.getUTCDate() + ' – ' + (x.getUTCMonth() === y.getUTCMonth() ? '' : MON[y.getUTCMonth()] + ' ') + y.getUTCDate();
  }
  // 今天最早还能自提的那一档 —— 规则同 stepper pickupSlots():max(地板时刻, 下单整点 + 备货小时)
  function rdPickupFirst(now) {
    var dd = window.TPDeliveryData || {}, ps = dd.PICKUP_SAMEDAY || { floorHour: 15, prepHours: 2 };
    var list = (dd.PICKUP_WINDOWS && dd.PICKUP_WINDOWS.weekday) || [];
    var min = Math.max(ps.floorHour, Math.floor(now.mins / 60) + ps.prepHours), off = offFor(fmtYMD(now.ms));
    for (var k = 0; k < list.length; k++) { if (parseInt(list[k].start, 10) >= min && off.indexOf(list[k].id) < 0) return list[k]; }
    return null;
  }
  // 今天(i=0)/明天(i=1)此刻能做什么:both | pickup | closed(closed 带一句原因)
  function rdSameDay(i, iso, now) {
    var dd = window.TPDeliveryData || {}, C = dd.CUTOFFS || {}, noSame = dd.NO_SAMEDAY_DOW || [0];
    var dow = new Date(parseYMD(iso)).getUTCDay(), band = bandFor(iso);
    if (band && band.blocked) return { st: 'closed', why: band.key === 'closed' ? 'We’re closed this day.' : 'This date is fully booked.' };
    if (i === 0) {
      if (noSame.indexOf(dow) !== -1) return { st: 'closed', why: 'No same-day orders on Sundays.' };
      var first = rdPickupFirst(now);
      if (now.mins >= rdMins(C.pickup, 960) || !first) return { st: 'closed', why: 'Today’s orders have closed.' };
      var dc = rdMins(C.delivery, 870);
      if (now.mins >= dc) return { st: 'pickup', first: first, dc: dc };
      return { st: 'both' };
    }
    var ro = rdMins(C.middayNextDay, 1020);
    if (noSame.indexOf(dow) !== -1 && now.mins >= ro) return { st: 'closed', why: 'Orders for Sunday close at ' + rdClock(ro) + ' on Saturday.' };
    return { st: 'both' };
  }
  function rdBand(iso) { var b = bandFor(iso); return (b && !b.blocked && b.inPdp !== false) ? b : null; }
  function mountReadyDate(box) {
    if (!box || box._tpDone) return;
    var now = rdNow(); if (!now) return;
    box._tpDone = true;
    var card = box.closest('[data-tp-ready]');
    var express = !!card && card.getAttribute('data-tp-express') === 'true';
    var lead = parseInt(card ? card.getAttribute('data-tp-lead') : '', 10);
    if (isNaN(lead) || lead < ADVANCE_MIN_DAYS) lead = ADVANCE_MIN_DAYS;
    var picked = null, offsetWeeks = 0;
    var body = h('div', { class: 'tp-rd__body' }, []);
    var note = h('div', { class: 'tp-rd__note', 'aria-live': 'polite' }, []);
    var tail = h('div', { class: 'tp-rd__tail' }, []);   // Express 的截单行 + 提前订出口,排在提示框下面
    note.hidden = true;
    box.appendChild(h('p', { class: 'tp-rd__q' }, ['When do you need it?']));
    box.appendChild(body); box.appendChild(note); box.appendChild(tail);

    function say(cls, kids) { note.textContent = ''; note.className = 'tp-rd__note ' + cls; kids.forEach(function (k) { if (k) note.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); }); note.hidden = false; }
    // 绿档格子上不挂点(大多数日子是绿,全挂点黄红就不显眼了),只在选中后的提示里写 Open to book
    function okSay(iso) {
      var b = bandFor(iso); if (b && b.blocked) b = null;
      say('is-ok', [
        h('strong', null, [niceDate(iso) + ' — we’ll bring this date into your cart.']),
        b ? h('span', { class: 'tp-rd__pill' }, [pill(b)]) : ' ',
        (b && b.urge ? b.urge + ' ' : '') + 'Delivery and pickup are both available — you’ll choose your time slot in the cart.',
      ]);
    }
    function pickupSay(s) { say('is-warn', [h('strong', null, ['Today: pickup only. ']), 'Delivery for today closed at ' + rdClock(s.dc) + '. Pick it up free in Markham from ' + rdClock(rdMins(s.first.start, 1020)) + ' — or choose tomorrow for delivery. We’ll bring this date into your cart.']); }
    function track(reason, i) { tpEvt('tp_ready_date_pick', { funnel_stage: 'config', step: 'ready_card', reason: reason, detail: rdBucket(i) }); }
    function choose(iso) { picked = iso; intentSet(iso); cartDateSync(iso); nudgeAtc(); }
    function unchoose() { picked = null; intentClear(); cartDateSync(null); note.hidden = true; }
    function render() { now = rdNow() || now; body.textContent = ''; tail.textContent = ''; if (express) renderExpress(); else renderGrid(); }
    // 这款蛋糕(提前订)最早能订的一天:lead 天起第一个没订满/没休息的日子
    function earliest() { for (var k = lead; k < lead + 60; k++) { var e = fmtYMD(addDays(now.ms, k)), eb = bandFor(e); if (!(eb && eb.blocked)) return e; } return fmtYMD(addDays(now.ms, lead)); }

    function renderExpress() {
      var row = h('div', { class: 'tp-rd__xb' }, []);
      [0, 1].forEach(function (i) {
        var iso = fmtYMD(addDays(now.ms, i)), s = rdSameDay(i, iso, now);
        var b = h('button', { type: 'button', class: 'tp-rd__xbtn' + (s.st === 'closed' ? ' is-no' : '') + (picked === iso ? ' is-on' : ''),
          'aria-pressed': picked === iso ? 'true' : 'false', 'aria-disabled': s.st === 'closed' ? 'true' : null },
          [h('b', null, [i === 0 ? 'Today' : 'Tomorrow']), h('small', null, [s.st === 'closed' ? 'Not available' : s.st === 'pickup' ? 'Pickup only' : niceDate(iso)]),
            s.st !== 'closed' && rdBand(iso) ? h('span', { class: 'tp-rd__xband is-' + rdBand(iso).key }, [rdBand(iso).label]) : null]);
        b.addEventListener('click', function () {
          now = rdNow() || now;
          var s2 = rdSameDay(i, iso, now);
          if (s2.st === 'closed') {
            if (picked === iso) unchoose();
            var t2 = i === 0 ? rdSameDay(1, fmtYMD(addDays(now.ms, 1)), now) : null;
            say('is-warn', [h('strong', null, [(i === 0 ? 'Today' : 'Tomorrow') + ' isn’t available. ']), s2.why + (t2 && t2.st !== 'closed' ? ' Tomorrow is still open.' : '')]);
            track('closed', i); render(); return;
          }
          if (picked === iso) { unchoose(); render(); return; }
          choose(iso);
          if (s2.st === 'pickup') pickupSay(s2); else okSay(iso);
          track(s2.st === 'pickup' ? 'pickup_only' : 'ok', i); render();
        });
        row.appendChild(b);
      });
      body.appendChild(row);
      var C = (window.TPDeliveryData || {}).CUTOFFS || {};
      tail.appendChild(h('p', { class: 'tp-rd__cut' }, ['Same-day: order by ' + rdClock(rdMins(C.delivery, 870)) + ' for delivery, ' + rdClock(rdMins(C.pickup, 960)) + ' for pickup (Toronto time).']));
      var alt = altLink('express', 'ready_card', true);   // 带已选项去提前订版(11/3)
      if (alt) tail.appendChild(h('p', { class: 'tp-rd__alt' }, ['Need a later date? ', alt]));
    }

    function renderGrid() {
      var start = addDays(now.ms, offsetWeeks * 7 - new Date(now.ms).getUTCDay());
      var cells = RD_WEEKS * 7;
      body.appendChild(h('p', { class: 'tp-rd__range' }, [rdRange(start, addDays(start, cells - 1))]));
      var grid = h('div', { class: 'tp-rd__grid', role: 'group', 'aria-label': 'Choose a date' },
        DOW_MIN.map(function (x) { return h('span', { class: 'tp-rd__dow', 'aria-hidden': 'true' }, [x]); }));
      var seen = {};
      for (var k = 0; k < cells; k++) grid.appendChild(dayCell(addDays(start, k), seen));
      body.appendChild(grid);
      // 图例只列这 5 周里真的出现过的档位(没出现的列出来是噪音)
      var legs = BANDS.concat([BOOKED, CLOSED]).filter(function (b) { return seen[b.key]; });
      if (legs.length) body.appendChild(h('div', { class: 'tp-rd__legend' }, legs.map(function (b) {
        return h('span', { class: 'tp-rd__leg is-' + b.key }, [h('i', { 'aria-hidden': 'true' }, []), b.label]);
      })));
      var more = h('div', { class: 'tp-rd__more' }, []);
      if (offsetWeeks > 0) more.appendChild(navBtn('‹ Earlier dates', -RD_WEEKS));
      if ((offsetWeeks + RD_WEEKS) * 7 < RD_MAX_DAYS) more.appendChild(navBtn('Later dates ›', RD_WEEKS));
      body.appendChild(more);
    }
    function navBtn(txt, step) {
      var b = h('button', { type: 'button', class: 'tp-rd__link' }, [txt]);
      b.addEventListener('click', function () { offsetWeeks = Math.max(0, offsetWeeks + step); render(); });
      return b;
    }
    function dayCell(ms, seen) {
      var iso = fmtYMD(ms), i = Math.round((ms - now.ms) / 86400000), dt = new Date(ms), dn = dt.getUTCDate();
      if (i < 0 || i > RD_MAX_DAYS) return h('span', { class: 'tp-rd__day is-past', 'aria-hidden': 'true' }, [String(dn)]);
      var band = bandFor(iso);
      var kind = i < ADVANCE_MIN_DAYS ? 'exp' : i < lead ? 'soon' : (band && band.blocked) ? 'no' : 'ok';
      var tag = i === 0 ? 'Today' : i === 1 ? 'Tmrw' : dn === 1 ? MON[dt.getUTCMonth()] : null;
      var shown = kind === 'ok' ? rdBand(iso) : null;   // 今明(Express 格)与提前期内的格子不挂档位
      if (shown) seen[shown.key] = 1;
      if (kind === 'no') seen[band.key] = 1;
      var cell = h('button', { type: 'button', class: 'tp-rd__day is-' + kind + (shown ? ' has-band band-' + shown.key : '') + (picked === iso ? ' is-on' : ''),
        'aria-pressed': picked === iso ? 'true' : 'false', 'aria-disabled': kind === 'no' || kind === 'soon' ? 'true' : null,
        'aria-label': niceDate(iso) + (kind === 'exp' ? ' — Express only' : kind === 'no' ? ' — ' + band.label : shown ? ' — ' + shown.label : '') },
        [String(dn), tag ? h('small', null, [tag]) : null, shown ? h('span', { class: 'tp-rd__dot' + (shown.pulse ? ' is-pulse' : ''), 'aria-hidden': 'true' }, []) : null]);
      cell.addEventListener('click', function () { clickDay(iso, i, kind, band); });
      return cell;
    }
    function clickDay(iso, i, kind, band) {
      now = rdNow() || now;
      if (kind === 'exp') {
        var s = rdSameDay(i, iso, now);
        var lead1 = 'This cake needs ' + lead + ' days’ notice. ';
        var t1 = i === 0 ? rdSameDay(1, fmtYMD(addDays(now.ms, 1)), now) : null;
        // 今明都做不了(例:周六 5 PM 后点周日)→ 不推 Express,直接报这款最早哪天
        if (s.st === 'closed' && !(t1 && t1.st !== 'closed')) { say('is-warn', [lead1 + s.why + ' The earliest date for this cake is ' + niceDate(earliest()) + '.']); track('closed', i); return; }
        // 今天关了、明天还行 → 按钮指向明天;否则指向点的这一天。有配对商品给按钮(11/3),没有照旧给链接
        var pushTmr = s.st === 'closed', dIso = pushTmr ? fmtYMD(addDays(now.ms, 1)) : iso, dS = pushTmr ? t1 : s;
        var dayWord = (pushTmr || i === 1) ? 'tomorrow' : 'today', pickupOnly = !pushTmr && i === 0 && s.st === 'pickup';
        var btn = swapButton(dIso, pickupOnly ? 'for pickup today' : dayWord, 'ready_card');
        var alt = btn ? null : altLink('advance', 'ready_card');
        if (btn) say('is-warn', [h('strong', null, [lead1 + (pushTmr ? s.why + ' ' : '') + 'Need it ' + dayWord + '?']), ' Its Express version is made for today and tomorrow.', btn,
          pickupOnly ? h('small', { class: 'tp-rd__xnote' }, ['Today it’s pickup only — delivery for today has closed.']) : null]);
        else if (pushTmr) say('is-warn', [lead1 + s.why + ' Need it tomorrow? ', alt]);
        else say('is-warn', [lead1 + 'Need it ' + dayWord + '? ', alt, pickupOnly ? ' (Today it’s pickup only.)' : '']);
        if (btn || alt) altImpressionOnce(note, 'ready_card');
        track('express_only', i); return;
      }
      if (kind === 'soon') { say('is-warn', ['This cake needs ' + lead + ' days’ notice — the earliest date is ' + niceDate(earliest()) + '.']); track('too_soon', i); return; }
      if (kind === 'no') {
        say('is-warn', [h('strong', null, [niceDate(iso) + ' — ']), band.key === 'closed' ? 'We’re closed this day. Please pick another date.' : 'This date is fully booked. Please pick another date.']);
        tpBlockedClick(iso, band.key === 'closed' ? 'closed' : 'booked', i); return;
      }
      if (picked === iso) { unchoose(); render(); return; }
      choose(iso); okSay(iso); track('ok', i); render();
    }

    // 同一标签页回到商品页:把之前点的日子恢复出来(只恢复这页现在还能订的)
    var saved = intentGet();
    if (saved) {
      var si = Math.round((parseYMD(saved) - now.ms) / 86400000), sb = bandFor(saved);
      if (express ? (si === 0 || si === 1) && rdSameDay(si, saved, now).st === 'both' : si >= lead && si <= RD_MAX_DAYS && !(sb && sb.blocked)) {
        picked = saved; offsetWeeks = express ? 0 : Math.floor((si + new Date(now.ms).getUTCDay()) / 7 / RD_WEEKS) * RD_WEEKS;
        okSay(saved);
      }
    }
    render();
    setInterval(render, 60000);   // 页面开着跨过 2:30 / 4:00 截单,按钮状态自己跟上
  }

  window.TPSlots = {
    ready: !!D,
    BANDS: BANDS,
    dayFor: dayFor,
    bandFor: bandFor,
    blocked: blocked,
    offFor: offFor,
    holidayFor: holidayFor,
    decorateDay: decorateDay,
    renderCartStatus: renderCartStatus,
    renderPdp: renderPdp,
    mountReadyDate: mountReadyDate,
    // PDP 意向日期通道(tp-delivery-stepper.js applyPdpIntent 消费;key 只在本文件出现)
    intent: { get: intentGet, set: intentSet, clear: intentClear },
  };

  function initPdp() {
    renderPdp(); renderExpressAlt();
    Array.prototype.forEach.call(document.querySelectorAll('[data-tp-ready-date]'), mountReadyDate);
  }
  if (document.readyState !== 'loading') initPdp();
  else document.addEventListener('DOMContentLoaded', initPdp);
})();
